let activeScope: string | null = null

export function setAutosaveScope(scope: string | null): void { activeScope = scope }
export function currentAutosaveScope(): string | null { return activeScope }
